import { DialogClose } from './dialog'
import { cn } from '../lib/utils'

/**
 * The `esc` chip — a dialog close affordance that names its own keyboard
 * shortcut.
 *
 * Mirrors the key rather than replacing it: base-ui's Dialog already closes on
 * Esc, and this makes that discoverable instead of leaving it as folklore. Sits
 * where a close control is expected (top right), so it costs nothing and
 * teaches the shortcut.
 *
 * Pair it with `showCloseButton={false}` on `DialogContent` — otherwise the
 * default X renders alongside and the corner ends up with two ways to do the
 * same thing.
 *
 * Lifted here from apps/wir, which had the only copy. Connect's "what's new"
 * dialog wanted the same chip, and a second copy would have drifted; wir's file
 * now re-exports this one, so every call site it already had is unchanged.
 *
 * `DialogClose` comes from this package's own dialog module rather than
 * `@base-ui/react/dialog` directly — that way the Close primitive resolves to
 * the same base-ui instance as `DialogContent` and can find the Root context.
 */
export function EscCloseButton({ className }: { className?: string }) {
  return (
    <DialogClose
      data-slot="dialog-close"
      aria-label="Close (press Esc)"
      className={cn(
        'absolute right-4 top-4 z-50 inline-flex h-7 min-w-[2.25rem] items-center justify-center rounded-md border border-border/70 bg-card/70 px-2 font-mono text-[10px] font-semibold lowercase tracking-[0.04em] text-muted-foreground backdrop-blur-md transition-colors hover:border-border hover:bg-card hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--brand-hot)] focus-visible:ring-offset-2 focus-visible:ring-offset-background',
        className
      )}
    >
      esc
    </DialogClose>
  )
}
